/* eslint-disable no-undef */
/* eslint-disable max-statements */
import React, { useState, useEffect, useRef, createRef } from "react";
import loadable from "@loadable/component";
import Download from "./images/download.svg";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import { AADHAR_EKYC_DOCS, DIY_DOCUMENT_VERFIFICATION_STATES, DIY_DOCUMENT_VERFIFICATION_STATE_MESSAGES, DIY_DOCUMENT_VIEW_ONLY_STATES, DIY_DOC_TYPES, REQUIRED_DOCUMENTS_CATEGORY, REQUIRED_DOCUMENTS_LIST } from "../post-inspection-diy/constant";
import { sendCustomGaEvents } from "../../../tracking";
import styles from "./styles.css";
import { isInvalidFileSize, isInvalidFileFormat } from "../../../utils/helpers/file-handler";
import { docUploadCommon } from "./tracking";
import PageLoader from "../../shared/page-loader";
import { checkIfMisMatch, getDocumentProgressStyle } from "../post-inspection-diy-doc-upload/selector";
import MissMatchSemiModal from "../miss-match-semi-modal";
import { getDocDetails } from "../post-inspection-diy/selector";
import { CONSENT_OPTIONS } from "../required-document-upload-card/constant";
import EkycLoader from "./ekyc-loader";
import { callVerificationGA } from "./selector";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import Error from "./images/error.svg";
const RtoDocumentsInfo = loadable(() => import("../rto-documents-info"));
const RequiredDocumentUploadCard = loadable(() => import("../required-document-upload-card"));
const UploadDocumentPopup = loadable(() => import("../upload-document-popup"));
// const DocumentsCollectPopup = loadable(() => import("../documents-collect-popup"));

// eslint-disable-next-line complexity
const RequiredDocumentUpload = ({
    allDocuments = {},
    uploadDocumentToDMSConnect,
    dmsLoginData,
    dmsLoginConnect,
    appointmentId,
    categoryText = true,
    showRtoInfo = true,
    forDriverVerification = false,
    uploadOnlyByCamera = false,
    callBack = () => {},
    fetchRequiredDocumentListConnect,
    client = "diy-mweb",
    isTokenDocAccepted = true,
    handleDiyPaymentApprovalProcess,
    uploadSource = "RUNNER",
    postTokenDocuments,
    showDocumentProgress = false,
    isDocUploadAllowed = true,
    callDocUploadPageViewGaEvent = () => {},
    children,
    inspectionResponse,
    dowloadConsentLetterConnect,
    verifyEkycDocumentConnect,
    diyPaymentApprovalProcessConnect,
    verifyDocumentUploadConnect = () => {},
    requiredDocumentType = REQUIRED_DOCUMENTS_LIST.KYC_DOCUMENTS
}) => {
    const {tokens} = useTokens();
    const {
        [requiredDocumentType]: {
            total: totalDocumentCount = NUMBER.ZERO,
            UPLOAD_PENDING: pendingDocumentCount = NUMBER.ZERO
        } = {}
    } = postTokenDocuments || {};
    const isKycDocument = requiredDocumentType === REQUIRED_DOCUMENTS_LIST.KYC_DOCUMENTS;
    const allDocRefs = useRef([]);
    const { token } = inspectionResponse || {};
    const [documentsToUpload, setDocumentsToUpload] = useState({});
    const [showUploadOnMisMatch, setShowUploadOnMisMatch] = useState({
        showUpload: false,
        uploadDocType: ""
    });
    const [uploadedDocumentDetail, setUploadedDocumentDetail] = useState();
    const [uploadedDocumentRef, setUploadedDocumentRef] = useState();
    const [uploadedPhoto, setUploadedPhoto] = useState(null);
    const [showDocumentUploadDetailModal, setShowDocumentUploadDetailModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [misMatchDetails, setMisMatchDetails] = useState(null);
    const [isDocumentUploading, setIsdocumentUploading] = useState(false);
    const documentUploadCount = totalDocumentCount - pendingDocumentCount;
    const documentProgressStyle = getDocumentProgressStyle(documentUploadCount, totalDocumentCount);
    const allowedDocumentUploadStates = [
        DIY_DOCUMENT_VERFIFICATION_STATES.UPLOADED,
        DIY_DOCUMENT_VERFIFICATION_STATES.REJECTED,
        DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_FAILED,
        DIY_DOCUMENT_VERFIFICATION_STATES.UPLOAD_PENDING,
        DIY_DOCUMENT_VERFIFICATION_STATES.PARTIALLY_MATCHED
    ];

    useEffect(() => {
        callDocUploadPageViewGaEvent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const sendErrorGA = (docDetails, type = null) => {
        sendCustomGaEvents({
            ...docUploadCommon,
            eventLabel: appointmentId,
            eventAction: `${docDetails.type || docDetails.code} Upload - Error ${type ? `- ${  DIY_DOCUMENT_VERFIFICATION_STATE_MESSAGES[type]}` : ""}`,
            event: `${docDetails.type || docDetails.code} - Doc Upload Error`
        });
    };

    const arePagesOrDocUploaded = (document) => {
        return document.pages && document.pages.length && document.uploads && document.uploads.length && document.uploads.length === document.pages.length
            || ((!document.pages || (document.pages && !document.pages.length)) && document.uploads && document.uploads.length);
    };

    const isCurrentDocumentUploaded = (document, currentState) => {
        let documentState = currentState;
        if (document.alternative && document.alternative.length) {
            document.alternative.forEach(element => {
                if (arePagesOrDocUploaded(element)) {
                    documentState = DIY_DOCUMENT_VERFIFICATION_STATES.UPLOADED;
                }
            });
        } else if (arePagesOrDocUploaded(document)) {
            documentState = DIY_DOCUMENT_VERFIFICATION_STATES.UPLOADED;
        }
        if (document.status) {
            documentState = DIY_DOCUMENT_VERFIFICATION_STATES[document.status];
        }
        return documentState;
    };

    const setDocumentsData = (errorState = null, errorReason = null) => {
        const allDocsToUpload = {};
        let overallIndex = 0;
        Object.keys(allDocuments).forEach((documentCategory) => {
            if (allDocuments[documentCategory] && allDocuments[documentCategory].length) {
                allDocsToUpload[documentCategory] = [];
                allDocuments[documentCategory].forEach((element) => {
                    allDocsToUpload[documentCategory].push({
                        title: element.name,
                        state: isCurrentDocumentUploaded(element, DIY_DOCUMENT_VERFIFICATION_STATES.NOT_UPLOADED),
                        type: element.code,
                        code: element.code,
                        reason: element.verificationComments || "Verification Failed / Please re-upload",
                        alternatives: element.alternative,
                        pages: element.page || [],
                        uploads: element.uploads,
                        isSignatureRequired: element.isRequired || false,
                        ocrApplicable: element.ocrApplicable || false,
                        docOcrData: element.docOcrData || {}
                    });
                    if (!allDocRefs.current[overallIndex]) {
                        allDocRefs.current[overallIndex] = createRef();
                    }
                    overallIndex += NUMBER.ONE;
                    if (uploadedDocumentDetail) {
                        if (element.alternative && element.alternative.length) {
                            element.alternative.some(alternate => {
                                if (alternate.code === uploadedDocumentDetail.code) {
                                    allDocsToUpload[documentCategory][allDocsToUpload[documentCategory].length - 1].state = errorState;
                                    allDocsToUpload[documentCategory][allDocsToUpload[documentCategory].length - 1].reason = errorReason;
                                    return true;
                                }
                                return false;
                            });
                        } else if (element.code === uploadedDocumentDetail.code) {
                            allDocsToUpload[documentCategory][allDocsToUpload[documentCategory].length - 1].state = errorState;
                            allDocsToUpload[documentCategory][allDocsToUpload[documentCategory].length - 1].reason = errorReason;
                        }
                    }
                });
            }
        });
        setDocumentsToUpload(allDocsToUpload);
    };

    useEffect(() => {
        setDocumentsData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allDocuments]);

    const onPopupClose = (event, documentData = false) => {
        const allDocs = Object.assign({}, documentsToUpload);
        Object.keys(allDocs).some(docs => {
            if (allDocs[docs] && allDocs[docs].length) {
                allDocs[docs].some(element => {
                    if (uploadedDocumentDetail && (element.code === uploadedDocumentDetail.code)) {
                        if (uploadedDocumentRef && uploadedDocumentRef.current) {
                            uploadedDocumentRef.current.value = "";
                            if (documentData) {
                                uploadedDocumentRef.current.click();
                            }
                            return true;
                        }

                    }
                    return false;
                });
            }
        });
        if (!documentData) {
            setUploadedPhoto(null);
            setUploadedDocumentDetail(null);
            setShowDocumentUploadDetailModal(false);
            setUploadedDocumentRef(null);
        }
        setIsLoading(false);
        setShowUploadOnMisMatch({
            ...showUploadOnMisMatch,
            showUpload: false
        });
    };

    const setMisMatch = (doc) => {
        const { nameOnRC, nameOnDocument, type } = doc;
        const isAadhaar = AADHAR_EKYC_DOCS.includes(type);
        setMisMatchDetails({
            isAadhaar,
            nameOnDocument,
            ownerNameOnRc: nameOnRC,
            transactionStatus: doc.reason,
            docCode: type,
            ...getDocDetails(isAadhaar)
        });
    };

    const handleSettingMismatchDetails = (doc = null, type) => {
        if (checkIfMisMatch(doc)
        ) {
            setMisMatch(doc);
            setShowUploadOnMisMatch({
                ...showUploadOnMisMatch,
                uploadDocType: type,
                showUpload: false
            });
        } else {
            setMisMatchDetails(null);
        }
    };

    const postUploadHandler = (res = {}, docType) => {
        setIsFetching(false);
        setIsdocumentUploading(true);
        sendCustomGaEvents({
            ...docUploadCommon,
            eventLabel: appointmentId,
            eventAction: `${docType} Upload - Submitted`,
            event: `${docType} - Doc Upload Submitted`
        });
        if (res) {
            if (typeof handleDiyPaymentApprovalProcess === "function") {
                handleDiyPaymentApprovalProcess();
            } else {
                fetchRequiredDocumentListConnect(appointmentId);
            }
            callBack();
        }
        setIsdocumentUploading(false);
        onPopupClose(null);
    };

    const verifyHandler = (docType, documentData) => {
        setIsFetching(true);
        setIsLoading(false);
        const payload = {
            "docCode": docType
        };
        callVerificationGA(docType, appointmentId);
        if (documentData && !uploadedDocumentDetail) {
            setUploadedDocumentDetail({
                title: documentData.title
            });
        }
        verifyDocumentUploadConnect(token, payload).then((res) => {
            if (res.status === DIY_DOCUMENT_VERFIFICATION_STATES.PENDING) {
                window.setTimeout(() => {
                    setUploadedDocumentDetail(null);
                    handleDiyPaymentApprovalProcess();
                    setIsFetching(false);
                    if (uploadedDocumentRef && uploadedDocumentRef.current) uploadedDocumentRef.current.value = "";
                }, NUMBER.TEN_THOUSAND);
            } else if (checkIfMisMatch(res)) {
                setMisMatch(res);
                setShowUploadOnMisMatch({
                    ...showUploadOnMisMatch,
                    uploadDocType: res.type,
                    showUpload: false
                });
                setIsFetching(false);
            } else {
                setUploadedDocumentDetail(null);
                handleDiyPaymentApprovalProcess();
                setIsFetching(false);
            }
        }).catch(() => {
            setIsFetching(false);
        });
    };

    const handleUploadResponse = (res, isOcr = false, docType = "") => {
        const { data: uploadedData } = res;
        if (isOcr && !AADHAR_EKYC_DOCS.includes(docType)) {
            setIsdocumentUploading(false);
            verifyHandler(docType);
        } else {
            postUploadHandler(uploadedData, docType);
        }
    };

    // eslint-disable-next-line complexity
    const continueToUpload = (dmsData = null, docDetails = null) => {
        setIsdocumentUploading(true);
        setShowDocumentUploadDetailModal(false);
        const document = new FormData();
        const documentData = docDetails && docDetails.documentData ? docDetails.documentData : uploadedDocumentDetail;
        const docType = documentData.type || documentData.code;
        if (docType === DIY_DOC_TYPES.AADHAR_CARD) setIsFetching(true);
        const {ocrApplicable = false} = docDetails;
        document.set("file", docDetails && docDetails.file ? docDetails.file : uploadedPhoto);
        document.set("docCode", docType);
        document.set("appointmentId", appointmentId);
        document.set("isRetailPipeline", true);
        document.set("page", documentData.page ? documentData.page : "");
        document.set("imageSource", "receive");
        document.set("client", client);
        document.set("uploadSource", uploadSource);
        if (forDriverVerification) {
            document.set("verificationType", "RUNNER");
        }
        uploadDocumentToDMSConnect(document, dmsData ? dmsData : dmsLoginData).then(res => {
            handleUploadResponse(res, ocrApplicable, docType);
        }).catch(() => {
            if (docType === DIY_DOC_TYPES.AADHAR_CARD) setIsFetching(false);
            setIsdocumentUploading(false);
            sendErrorGA(documentData);
            if (uploadedDocumentRef && uploadedDocumentRef.current) uploadedDocumentRef.current.value = "";
            setIsLoading(false);
        });
    };

    const onConfirmUpload = (docDetails) => {
        if (!isTokenDocAccepted) return;
        setIsLoading(true);

        if (isInvalidFileSize(uploadedPhoto, NUMBER.TEN)) {
            setDocumentsData(DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_FAILED, DIY_DOCUMENT_VERFIFICATION_STATES.SIZE);
            sendErrorGA(docDetails, DIY_DOCUMENT_VERFIFICATION_STATES.SIZE);
            onPopupClose(null);
        } else if (isInvalidFileFormat(uploadedPhoto)) {
            setDocumentsData(DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_FAILED, DIY_DOCUMENT_VERFIFICATION_STATES.WRONG_FORMAT);
            sendErrorGA(docDetails, DIY_DOCUMENT_VERFIFICATION_STATES.WRONG_FORMAT);
            onPopupClose(null);
        } else if (dmsLoginData && !!Object.keys(dmsLoginData).length) {
            continueToUpload(null, docDetails);
        } else {
            dmsLoginConnect(appointmentId).then(({ data }) => {
                continueToUpload(data, docDetails);
            });
        }
    };

    const onImageUpload = ({event, documentData, ref, ocrApplicable = false}) => {
        if (isTokenDocAccepted &&
            (allowedDocumentUploadStates.includes(documentData.state) ||
            documentData.state === DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_PENDING) &&
            event.target.files && event.target.files[0]) {
            sendCustomGaEvents({
                ...docUploadCommon,
                eventLabel: appointmentId,
                eventAction: `${documentData.type || documentData.code} Upload - Attempted`,
                event: `${documentData.type || documentData.code} - Doc Upload Clicked`
            });
            setUploadedDocumentDetail(documentData);
            const { target: { files } } = event;
            const file = files && files.length > 0 ? files[0] : null;
            setUploadedPhoto(file);
            if (!documentData.page) {
                setShowDocumentUploadDetailModal(true);
                setUploadedDocumentRef(ref);
            } else {
                onConfirmUpload({documentData, file, ocrApplicable});
            }
        }
    };

    const renderProgress = () => {
        return (
            <p styleName={"styles.totalDocumentCount"}>
                Documents uploaded <strong styleName={documentProgressStyle}>{documentUploadCount}/{totalDocumentCount }</strong>
            </p>
        );
    };

    const closeMisMatchModal = () => {
        setMisMatchDetails(null);
        setShowUploadOnMisMatch({
            ...showUploadOnMisMatch,
            showUpload: true
        });
    };

    const downloadConsentLetterPdf = () => {
        dowloadConsentLetterConnect(appointmentId)
            .then((response) => {
                const link = document.createElement("a");
                link.href = response.detail;
                link.download = "consent_letter";
                link.click();
            });
    };

    return (
        <div styleName={"styles.wrapper"}>
            {
                showDocumentProgress && renderProgress()
            }
            {children}
            {
                !!(documentsToUpload && Object.keys(documentsToUpload) && Object.keys(documentsToUpload).length) &&
                Object.keys(documentsToUpload).map((element, index) => (
                    <React.Fragment key={index} >
                        {categoryText && <p styleName={"styles.categoryText"}>{REQUIRED_DOCUMENTS_CATEGORY[element]}</p>}
                        {
                            !!(documentsToUpload[element] && documentsToUpload[element].length) &&
                            documentsToUpload[element].map((doc, i) => (
                                <React.Fragment key={i}>
                                    <RequiredDocumentUploadCard
                                        isLoading={isLoading}
                                        appointmentId={appointmentId}
                                        docRef={allDocRefs.current[i]}
                                        documentData={doc}
                                        forDriverVerification={forDriverVerification}
                                        uploadOnlyByCamera={uploadOnlyByCamera}
                                        onImageUpload={onImageUpload}
                                        isTokenDocAccepted={isTokenDocAccepted}
                                        isDocUploadAllowed={isDocUploadAllowed && allowedDocumentUploadStates.includes(doc.state)}
                                        uploads={doc.uploads}
                                        showMaxSize={false}
                                        allowViewDocument={true}
                                        showErrorDetailsStatus={false}
                                        verifyHandler={verifyHandler}
                                        handleSettingMismatchDetails={handleSettingMismatchDetails}
                                        showMissMatcDocument={showUploadOnMisMatch}
                                    />
                                    {doc.type === DIY_DOC_TYPES.THIRD_PARTY_CONSENT_LETTER && !DIY_DOCUMENT_VIEW_ONLY_STATES.includes(doc.state) &&
                                    <div styleName={"styles.downloadLetter"}>
                                        <h5>Download consent letter template</h5>
                                        <div styleName={"styles.downlaodPdf"} onClick={downloadConsentLetterPdf}>
                                            <img src={Download} alt="download" />
                                            Download PDF
                                        </div>
                                    </div>}
                                </React.Fragment>
                            ))}
                    </React.Fragment>
                ))
            }
            {
                showDocumentUploadDetailModal &&
                <UploadDocumentPopup
                    onClose={onPopupClose}
                    onConfirmUpload={onConfirmUpload}
                    documentData={uploadedDocumentDetail}
                    uploadedPhoto={uploadedPhoto}
                    isLoading={isLoading}
                />
            }
            {!forDriverVerification && isKycDocument &&
                <div styleName="styles.documentationInfo">
                    <img src={ Error } alt="error" />
                    <Label
                        level={NUMBER.FOUR}
                        color={tokens.text_brand_text_accent}
                        fontWeight="regular">
                    You can proceed with one document now, but we strongly recommend uploading both documents, as they are required to be submitted before pickup.
                    </Label>
                </div>
            }
            {
                showRtoInfo &&
                <React.Fragment>
                    <p styleName={"styles.categoryText"}>{REQUIRED_DOCUMENTS_CATEGORY.RTO_DOCUMENTS}</p>
                    <RtoDocumentsInfo
                        isRTO={true}
                        text={"Some RTO forms essential for transferring your car require the car owner's original signatures. Worry not, our representative will bring them over for your signature!"}
                    />
                </React.Fragment>
            }
            {
                isDocumentUploading  && <PageLoader  opacity={0.7}  />
            }
            {   misMatchDetails &&
                <MissMatchSemiModal
                    token={token}
                    misMatchDetails={misMatchDetails}
                    appointmentId={appointmentId}
                    close={closeMisMatchModal}
                    consentOptions={CONSENT_OPTIONS}
                    verifyEkycDocumentConnect={verifyEkycDocumentConnect}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    handlePostConfirmation={() => setMisMatchDetails(null)}
                    diyPaymentApprovalProcessConnect={diyPaymentApprovalProcessConnect}
                />
            }
            {
                isFetching &&  <EkycLoader
                    title={uploadedDocumentDetail && uploadedDocumentDetail.title}
                    isVerifying={!isDocumentUploading}
                />
            }
        </div>
    );
};

RequiredDocumentUpload.propTypes = {
    allDocuments: PropTypes.any,
    uploadDocumentToDMSConnect: PropTypes.func,
    dmsLoginData: PropTypes.any,
    dmsLoginConnect: PropTypes.func,
    appointmentId: PropTypes.any,
    categoryText: PropTypes.bool,
    showRtoInfo: PropTypes.bool,
    uploadOnlyByCamera: PropTypes.bool,
    forDriverVerification: PropTypes.bool,
    callBack: PropTypes.func,
    client: PropTypes.any,
    fetchRequiredDocumentListConnect: PropTypes.func,
    isTokenDocAccepted: PropTypes.bool,
    handleDiyPaymentApprovalProcess: PropTypes.func,
    uploadSource: PropTypes.string,
    postTokenDocuments: PropTypes.object,
    showDocumentProgress: PropTypes.bool,
    isDocUploadAllowed: PropTypes.bool,
    callDocUploadPageViewGaEvent: PropTypes.func,
    inspectionResponse: PropTypes.object,
    children: PropTypes.any,
    dowloadConsentLetterConnect: PropTypes.func,
    verifyEkycDocumentConnect: PropTypes.func,
    diyPaymentApprovalProcessConnect: PropTypes.func,
    verifyDocumentUploadConnect: PropTypes.func,
    requiredDocumentType: PropTypes.string
};

export default RequiredDocumentUpload;
